import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './ServerError.scss';

import commonConstant from '../../common/_commonConstant';

export default class ServerError extends Component {
  render() {
    return (
      <div className="ServerError">
        <div className="box-page">
          <img className="logo" src={commonConstant.ezyParkLogo} alt="ezyParkLogo" />
          <div className="oops">
            Oops!
          </div>
          <div className="description" id="server-error">
            <span className="hilight">error 500</span>
            , something went wrong with our server, please try again or feel free to contact us if the problem persists.
          </div>
          <Link id="btn-ok" className="btn back btn-primary" to={commonConstant.pathCheckRedirect}>OK</Link>
        </div>
      </div>
    );
  }
}
